import {
  BoxGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  Object3DEventMap
} from "three";

import { PieceName } from "src/api/";
import {
  DARK_TILE_COLOR,
  LIGHT_TILE_COLOR,
  TILE_THICKNESS
} from "src/client/human/constants";
import {
  PIECE_DEFINITIONS,
  VARIANT_PIECE_DEFINITIONS
} from "src/client/human/game/board/worldObjects/pieces/pieceDefinitions";
import { loadGltf } from "src/client/human/render/models/loadGltf";

const SIZE_X = 8;
const SIZE_Y = 8;
const SIZE_HALF_X = Math.round(SIZE_X / 2);
const SIZE_HALF_Y = Math.round(SIZE_Y / 2);

export function createAPTiles(): Group {
  const board = new Group();
  const geometry = new BoxGeometry(1, TILE_THICKNESS, 1);
  const light = new MeshStandardMaterial({
    color: LIGHT_TILE_COLOR,
    roughness: 0.85
  });
  const dark = new MeshStandardMaterial({
    color: DARK_TILE_COLOR,
    roughness: 0.85
  });

  for (let x = 0 - SIZE_HALF_X; x < SIZE_HALF_X; x++) {
    for (let y = 0 - SIZE_HALF_Y; y < SIZE_HALF_Y; y++) {
      const tile = new Mesh(geometry, (x + y) % 2 === 0 ? light : dark);
      tile.position.set(x, -TILE_THICKNESS / 2, y);
      tile.receiveShadow = true;
      board.add(tile);
    }
  }

  return board;
}

export async function loadAllPieces(
  board: Group<Object3DEventMap>
): Promise<Group> {
  const loads = (
    (Object.keys(PIECE_DEFINITIONS) as PieceName[]) ||
    (Object.keys(VARIANT_PIECE_DEFINITIONS) as PieceName[])
  ).map((piece, i) => addPieceAt(board, piece, i - SIZE_HALF_X, -SIZE_HALF_Y));

  await Promise.all(loads);
  return board;
}

export async function addPieceAt(
  board: Group,
  piece: PieceName,
  x: number,
  y: number
) {
  const gltf = await loadGltf(PIECE_DEFINITIONS[piece].modelUrl);
  gltf.scene.position.set(x, 0, y);
  board.add(gltf.scene);
}
